<template>
  <div class="record-btn" ref="recordBtn">
    <span @click="clickHandler">
      <el-image
          :src="iconRecord"
          style="height: 20px;position: relative; top: 4px;"/>录音</span>
  </div>
</template>
<script>
import iconRecord from './iconRecord.png'
import {mapState, mapMutations} from 'vuex'

export default {
  data() {
    return {
      iconRecord
    }
  },
  computed: {
    ...mapState('record', ['recordDialogVisible']),
  },
  methods: {
    ...mapMutations('record', ['recordDialogShow', 'setOffsetLeft']),
    clickHandler() {
      this.recordDialogShow()
    }
  },
  mounted() {
    this.setOffsetLeft(this.$refs.recordBtn.getBoundingClientRect().left || 595)
  }
}
</script>
<style scoped lang="scss">
.record-btn {
  line-height: 40px;

  span {
    cursor: pointer;
  }
}
</style>